export default __webpack_public_path__ + "static/media/GiftSetProductInfo1_1.94b96432.jpg";